export default __webpack_public_path__ + "static/media/parkeasy4.6ec5fce9.png";